import { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addFilter,
  filter,
  getAllProducts,
  getProductsFiltered,
  deleteFilter,
  getProductsNextPage,
  filterAndKeepAll,
  clearAllFilters,
} from "../../actions/products-actions/actions";
import { Filter } from "../../components/Filter/Filter";
import { ProductCard } from "../../components/ProductCard/ProductCard";
import { Link } from "react-router-dom";
import { handleLeftDrawer, handleBottomDrawer } from "../../actions/actionCreators";
import { Card, Drawer, Skeleton, message, Divider, Tooltip } from "antd";
import Select from "antd/lib/select";
import { useParams, useLocation } from "react-router-dom";
import ReactSelect from "react-select";
import { getCollaborators } from "../../actions/order-actions/actions";
import "./MixProducts.scss";
import { FilterOutlined, ClearOutlined, PlusOutlined } from "@ant-design/icons";
import { Spinner } from "../../components/Spinner";
import backArrow from "../../img/backArrow.png";
import { history } from "../../index";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { addProducttoFolder, createFolder } from "../../actions/folders-actions/actions";
import { StandardDraggableProductCard } from "../ProductCard/StandardDraggableProductCard";
import placeholder_jeans from "../../img/placeholder_jeans.svg";
import ExampleProductCard from "../ProductCard/ExampleProductCard";
import axiosInstance from "../../config/axios-instance";
import ProductServices from "../../actions/products-actions/services";
import DenimProduct from "../ProductDetails/DenimProduct";
import KnitProduct from "../ProductDetails/KnitProduct";
import MixProduct from "../ProductDetails/MixProduct";
import BottomDrawer from "../BottomDrawer/BottomDrawer";
import Folder from "../Folder/Folder";
import PlusIcon from "../../icons/PlusIcon";
import { clearfolderToMoveTo } from "../../actions/folders-actions/actions";
import "../AddToCollection/AddToCollection.scss";
import { Button as DemcoButton } from "../Button/Button";
interface Props {}

const { Meta } = Card;

export const MixProducts = (props: Props) => {
  const location = useLocation();
  const params: any = useParams();
  const [min_price_allowed, setMin_price_allowed] = useState(0);
  const [max_price_allowed, setMax_price_allowed] = useState(1000);
  const [min_price, setMin_price] = useState(0);
  const [max_price, setMax_price] = useState(1000);
  const [min_priceBefore, setMin_priceBefore] = useState(1);
  const [max_priceBefore, setMax_priceBefore] = useState(1000);
  const [min_elasticity, setMin_elasticity] = useState(1);
  const [max_elasticity, setMax_elasticity] = useState(1000);
  const [min_elasticity_before, setMin_elasticity_before] = useState(1);
  const [max_elasticity_before, setMax_elasticity_before] = useState(1000);
  const [min_elasticity_allowed, setMin_elasticity_allowed] = useState(1);
  const [max_elasticity_allowed, setMax_elasticity_allowed] = useState(1000);

  const [min_weight, setMin_weight] = useState(1);
  const [max_weight, setMax_weight] = useState(1000);
  const [min_weight_before, setMin_weight_before] = useState(1);
  const [max_weight_before, setMax_weight_before] = useState(1000);
  const [min_weight_allowed, setMin_weight_allowed] = useState(1);
  const [max_weight_allowed, setMax_weight_allowed] = useState(1000);
  const [forYouCompany, setForYouCompany] = useState<any>(null);

  const [count, setcount] = useState(0);
  const [highestPrice, setHighestPrice] = useState(0);
  const [queries, setQueries] = useState<Array<string>>([]);
  const [width, setWidth] = useState(window.innerWidth);
  const [openFilterDrawer, setOpenFilterDrawer] = useState(false);
  const [url, setUrl] = useState(`/products`);
  
  const dispatch = useDispatch();

  const [quickViewProduct, setQuickViewProduct] = useState<any>(null);
  const [quickViewVisible, setQuickViewVisible] = useState(false);
  const [showCollectionForm, setShowCollectionForm] = useState(false);

  const [folderData, setFolderData] = useState({
    name: "",
    description: "",
    collaborator: [],
    season: '',
    year: ""
  });

  const { collaborators } = useSelector((state: any) => state.orders);

  const customStylesCreate = {
    control: (base: any) => ({
      ...base,
      border: 0,
      borderBottom: "1px solid #ccc",
      borderRadius: 0,
      padding: 0,
      boxShadow: "none",
      "&:hover": {
        outline: "none",
      },
    }),
    valueContainer: (base: any) => ({
      ...base,
      paddingLeft: 0,
    }),
  };

  const customStylesCreateModern = {
    control: (base: any, state: any) => ({
      ...base,
      background: "white",
      borderColor: state.isFocused ? "#00468c" : "#e2e8f0",
      borderRadius: "8px",
      padding: "2px",
      fontSize: "14px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#00468c",
      },
    }),
    placeholder: (base: any) => ({
      ...base,
      color: "#94a3b8",
    }),
    menu: (base: any) => ({
      ...base,
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e2e8f0",
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? "#00468c" : state.isFocused ? "#f1f5f9" : "white",
      color: state.isSelected ? "white" : "#1e293b",
      padding: "10px 12px",
      fontSize: "14px",
      cursor: "pointer",
      "&:active": {
        backgroundColor: "#00468c",
      },
    }),
  };

  const currentYear = new Date().getFullYear();
  const options_year = [
    { value: String(currentYear).slice(2), label: String(currentYear) },
    { value: String(currentYear + 1).slice(2), label: String(currentYear + 1) },
    { value: String(currentYear + 2).slice(2), label: String(currentYear + 2) },
    { value: String(currentYear + 3).slice(2), label: String(currentYear + 3) },
    { value: String(currentYear + 4).slice(2), label: String(currentYear + 4) },
  ];

  const options_season = [
    { value: 'ps', label: 'PS' },
    { value: 'ss', label: 'SS' },
    { value: 'pf', label: 'PF' },
    { value: 'fw', label: 'FW' }
  ];

  const handleCreateNewFolder = () => {
    if (!folderData.name) {
      message.error("Please specify the collection name!");
      return;
    }
    dispatch(createFolder({ ...folderData, product_id: quickViewProduct?.id }));
    setShowCollectionForm(false);
    setFolderData({ name: "", description: "", collaborator: [], season: '', year: "" });
    message.success("Collection created successfully");
  };

  useEffect(() => {
    dispatch(getCollaborators(""));
  }, [dispatch]);
  const folders = useSelector((state: any) => state.folders);
  const { user } = useSelector((state: any) => state.auth);

  const openQuickView = async (product: any) => {
    setQuickViewProduct(product);
    setQuickViewVisible(true);
    
    // Fetch full details
    try {
        const response = await ProductServices.getOneProduct(product.id);
        const fullProduct = response.data || response;
        setQuickViewProduct(fullProduct);
    } catch (error) {
        console.error("Error fetching full product details", error);
    }
  };



  const {
    products,
    productsAll,
    isLoading,
    next_page,
    filters,
    isLoadingNext,
    prices,
    elasticity_fabric,
    weight_fabric,
  } = useSelector((state: any) => state.products);

  useEffect(() => {
    if (count > 0 && url.includes("fabric_types")) {
      dispatch(filter(url.replace("&&", "&")));
    }
    dispatch(addFilter(queries));
  }, [url]);
  useEffect(() => {
    setMax_price(0);
    setMin_price(0);
    setMax_price_allowed(0);
    setMin_price_allowed(0);
  }, []);

  useEffect(() => {
    dispatch(filterAndKeepAll(`/products?fabric_types=${params.fabric}`));
  }, [location.pathname]);

  useEffect(() => {
    let resize = () =>
      window.addEventListener("resize", () => {
        setWidth(window.innerWidth);
      });
    resize();
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    if (productsAll.length) {
      setMax_price(prices.max_price);
      setMin_price(prices.min_price);
      setMax_price_allowed(prices.max_price);
      setMin_price_allowed(prices.min_price);

      setMin_priceBefore(prices.min_price);
      setMax_priceBefore(prices.max_price);
      setMin_elasticity(elasticity_fabric.min_elasticity_value);
      setMax_elasticity(elasticity_fabric.max_elasticity_value);
      setMin_elasticity_before(elasticity_fabric.min_elasticity_value);
      setMax_elasticity_before(elasticity_fabric.max_elasticity_value);
      setMax_elasticity_allowed(elasticity_fabric.max_elasticity_value);
      setMin_elasticity_allowed(elasticity_fabric.min_elasticity_value);

      setMin_weight(weight_fabric.min_weight_value);
      setMax_weight(weight_fabric.max_weight_value);
      setMin_weight_before(weight_fabric.min_weight_value);
      setMax_weight_before(weight_fabric.max_weight_value);
      setMax_weight_allowed(weight_fabric.max_weight_value);
      setMin_weight_allowed(weight_fabric.min_weight_value);
    }
  }, [productsAll]);

  useEffect(() => {
    const company_id = localStorage.getItem("company_id");

    if (!forYouCompany && company_id) {
      getForYouCompany(company_id);
    }
  }, []);

  const getForYouCompany = async (company_id: string) => {
    let token = localStorage.getItem("token");
    if (company_id) {
      await axiosInstance({
        method: "get",
        url: `/admin/forYouCompany/${company_id}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(function (response) {
        setForYouCompany(response.data);
      });
      return "ok";
    }
  };

  useEffect(() => {
    // if (!max_price && !min_price) {
    //   setUrl(
    //     params.fabric === "denim"
    //       ? `/products?new=true&fabric_types=${params.fabric}&${queries.join(
    //           "&"
    //         )}&elasticity_min=${min_elasticity}&elasticity_max=${max_elasticity}`
    //       : `/products?new=true&fabric_types=${params.fabric}&${queries.join(
    //           "&"
    //         )} `
    //   );
    // } else {
    if (max_price || min_price) {
      setUrl(
        params.fabric === "denim"
          ? `/products?fabric_types=${params.fabric}&${queries.join(
              "&"
            )}&min_price=${min_price}&max_price=${max_price}
            &elasticity_min=${min_elasticity}&elasticity_max=${max_elasticity}&weight_min=${min_weight}&weight_max=${max_weight}`
          : `/products?fabric_types=${params.fabric}&${queries.join(
              "&"
            )}&min_price=${min_price}&max_price=${max_price}`
      );
    }
    // }
    // setUrl(
    //   `/products?new=true&${queries.join(
    //     "&"
    //   )}&min_price=${min_price}&max_price=${max_price}`
    // );
    setcount(count + 1);
  }, [
    min_price,
    max_price,
    min_elasticity,
    max_elasticity,
    min_weight,
    max_weight,
    queries,
  ]);

  const getNextPageProducts = () => {
    dispatch(
      params.fabric === "denim"
        ? getProductsNextPage(
            next_page.substr(process.env.REACT_APP_URL_LENGTH) +
              `&fabric_types=${params.fabric}&${queries.join(
                "&"
              )}&min_price=${min_price}&max_price=${max_price}
        &elasticity_min=${min_elasticity}&elasticity_max=${max_elasticity}`
          )
        : getProductsNextPage(
            next_page.substr(process.env.REACT_APP_URL_LENGTH) +
              `&fabric_types=${params.fabric}&${queries.join(
                "&"
              )}&min_price=${min_price}&max_price=${Number(
                max_price.toString()
              )}`
          )
    );
  };

  const handleChangeWeight = (val: any) => {
    let [min, max] = val;
    // setMin_elasticity(min === 0 ? "0.00" : min);
    setMin_weight(min);
    setMax_weight(max);
  };

  const fetchData = async () => {

    if (next_page) {
      dispatch(
        params.fabric === "denim"
          ? getProductsNextPage(
              //test vesion 67
              //prod version 69
              //local version 40
              next_page.substr(45) +
                `&fabric_types=${params.fabric}&${queries.join(
                  "&"
                )}&min_price=${min_price}&max_price=${max_price}
          &elasticity_min=${min_elasticity}&elasticity_max=${max_elasticity}`
            )
          : getProductsNextPage(
              //test vesion 67
              //prod version 69
              //local version 40
              next_page.substr(45) +
                `&fabric_types=${params.fabric}&${queries.join(
                  "&"
                )}&min_price=${min_price}&max_price=${Number(
                  max_price.toString()
                )}`
            )
      );
    }
  };

  // Intersection Observer for Infinite Scroll
  const observer = useRef<IntersectionObserver | null>(null);
  const lastProductElementRef = useCallback(
    (node) => {
      if (isLoadingNext || isLoading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && next_page) {
          fetchData();
        }
      });

      if (node) observer.current.observe(node);
    },
    [isLoadingNext, isLoading, next_page]
  );

  var regInteger = /^-?\d+$/;
  //@ts-ignore
  const pathnames = props.location.pathname
    .split("/")
    .filter((element: any) => !regInteger.test(element))
    .map((el: string) => {
      return el.charAt(0).toUpperCase() + el.slice(1);
    })
    .filter((x: string) => x);

  useEffect(() => {
    setUrl(`/products?${queries.join("&")}`.replace("&&", "&"));
  }, [params]);

  //works fine
  const handleChangePrice = (val: any) => {
    let [min, max] = val;
    setMin_price(min);
    setMax_price(max);
  };
  // //works fine
  // const addQuery = (target: any) => {
  //   const element = target.name + "=" + target.id;
  //   if (target.checked) {
  //     setQueries([...queries, element]);
  //   } else if (!target.checked) {
  //     setQueries(queries.filter((el) => el !== element));
  //   }
  // };
  // //works fine
  // const deleteFilterTag = (obj: any) => {
  //   setQueries(queries.filter((el) => el !== obj.filteredBy + "=" + obj.id));
  // };

  const handleChangePriceAfter = (val: any) => {
    let [min, max] = val;
    setMin_priceBefore(min);
    setMax_priceBefore(max);
  };

  const handleChangeElasticity = (val: any) => {
    let [min, max] = val;
    setMin_elasticity(min);
    setMax_elasticity(max);
  };

  const addQuery = (target: any) => {
    const element = target.name + "=" + target.id;
    if (target.checked) {
      var exists = queries.filter((query: any) => query.includes(target.name));
      if (exists.length === 0) {
        setQueries([...queries, element]);
      } else {
        var newQueryVal = exists[0].concat("," + target.id);
        setQueries(
          queries.map((el: any) =>
            el.includes(target.name) ? newQueryVal : el
          )
        );
      }
    } else if (!target.checked) {
      var exist = queries.filter((query: any) =>
        query.includes(target.name)
      )[0];

      if (exist.includes(",") === false) {
        setQueries(queries.filter((el) => !el.includes(target.name)));
      } else if (
        exist.indexOf(target.id) ===
        exist.length - target.id.toString().length
      ) {
        var newQuery = exist.substr(
          0,
          exist.length - (target.id.toString().length + 1)
        );
        setQueries(
          queries.map((el: any) => (el.includes(target.name) ? newQuery : el))
        );
      } else {
        var newQuery = exist.replace(target.id + ",", "");
        setQueries(
          queries.map((el: any) => (el.includes(target.name) ? newQuery : el))
        );
      }
    }
  };

  const deleteFilterTag = (obj: any) => {
    // setQueries(queries.filter((el) => el !== obj.filteredBy + "=" + obj.id));
    var exist = queries.filter((query: any) =>
      query.includes(obj.filteredBy)
    )[0];
    // if (obj.filteredBy.length === exist.length - 2) {
    if (exist.includes(",") === false) {
      setQueries(queries.filter((el) => !el.includes(obj.filteredBy)));
    } else if (
      exist.indexOf(obj.id) ===
      exist.length - obj.id.toString().length
    ) {
      var newQuery = exist.substr(
        0,
        exist.length - (obj.id.toString().length + 1)
      );
      setQueries(
        queries.map((el: any) => (el.includes(obj.filteredBy) ? newQuery : el))
      );
    } else {
      var newQuery = exist.replace(obj.id + ",", "");
      setQueries(
        queries.map((el: any) => (el.includes(obj.filteredBy) ? newQuery : el))
      );
    }
  };

  const onDragEnd = useCallback((draggable: any) => {
    const { destination, draggableId } = draggable;

    if (draggableId) {
      if (draggableId.includes("draggable-product")) {
        const productData = JSON.parse(draggableId);

        const productId = productData.draggableId.substring(
          "draggable-product".length
        );
        const currentproductParentId = productData.parentId;
        if (destination && destination.droppableId) {
          if (destination.droppableId.includes("droppable-minature")) {
            const newParentIdDroppable = destination.droppableId.substring(
              "droppable-minature".length
            );
            if (newParentIdDroppable !== currentproductParentId) {
              dispatch(addProducttoFolder(newParentIdDroppable, productId));
              setIsDragging(false);
            }
          }
        }
      }
    }
    setIsDragging(false);
  }, []);
  const [isDragging, setIsDragging] = useState<boolean>(false);

  const onDragStart = () => {
    setIsDragging(true);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
      <div className="products_page_container_product">
        <div className={`container-fluid products_page`}>
          {width >= 1000 && (
            <div className="filter_collection">
              <Filter
                setMax_elasticity_before={setMax_elasticity_before}
                setMin_elasticity_before={setMin_elasticity_before}
                max_elasticity_before={max_elasticity_before}
                min_elasticity_before={min_elasticity_before}
                isDragging={isDragging}
                fabric=""
                categoryId=""
                genderId=""
                handleChangePrice={handleChangePrice}
                min_price={min_price}
                max_price={max_price}
                urlProp={url}
                setUrl={setUrl}
                queries={queries}
                addQuery={addQuery}
                highestPrice={highestPrice}
                min_price_allowed={min_price_allowed}
                max_price_allowed={max_price_allowed}
                setMax_price={setMax_price}
                setMin_price={setMin_price}
                setMax_price_allowed={setMax_price_allowed}
                setMin_price_allowed={setMin_price_allowed}
                handleChangePriceAfter={handleChangePriceAfter}
                max_priceBefore={max_priceBefore}
                min_priceBefore={min_priceBefore}
                max_elasticity={max_elasticity}
                min_elasticity={min_elasticity}
                handleChangeElasticity={handleChangeElasticity}
                setMax_weight_before={setMax_weight_before}
                setMin_weight_before={setMin_weight_before}
                max_weight_before={max_weight_before}
                min_weight_before={min_weight_before}
                max_weight={max_weight}
                min_weight={min_weight}
                handleChangeWeight={handleChangeWeight}
              />
            </div>
          )}
          <div className="products_list">
            <div className="filter_tags_wrapper">
              <div style={{ width: "90%" }}>
                {width >= 1000 ? (
                  ((filters && filters.length > 0) ||
                    max_price_allowed !== max_price ||
                    min_price_allowed !== min_price ||
                    max_elasticity !== max_elasticity_allowed ||
                    min_elasticity !== min_elasticity_allowed ||
                    max_weight !== max_weight_allowed ||
                    min_weight !== min_weight_allowed) && (
                    <p>Selected Filters:</p>
                  )
                ) : (
                  <button
                    className="filter_product_button"
                    onClick={() => setOpenFilterDrawer(true)}
                  >
                    <FilterOutlined className="mr-2" /> Filter
                  </button>
                )}
                <Drawer
                  title="FILTER"
                  placement={"left"}
                  closable={true}
                  onClose={() => setOpenFilterDrawer(false)}
                  visible={openFilterDrawer}
                  key={"left"}
                >
                  <div className="p-3">
                    <Filter
                      setMax_elasticity_before={setMax_elasticity_before}
                      setMin_elasticity_before={setMin_elasticity_before}
                      max_elasticity_before={max_elasticity_before}
                      min_elasticity_before={min_elasticity_before}
                      isDragging={isDragging}
                      fabric={params.fabric}
                      categoryId={params.categoryId}
                      genderId={params.genderId}
                      handleChangePrice={handleChangePrice}
                      min_price={min_price}
                      max_price={max_price}
                      urlProp={url}
                      setUrl={setUrl}
                      queries={queries}
                      addQuery={addQuery}
                      setMax_price={setMax_price}
                      setMin_price={setMin_price}
                      setMax_price_allowed={setMax_price_allowed}
                      setMin_price_allowed={setMin_price_allowed}
                      handleChangePriceAfter={handleChangePriceAfter}
                      max_priceBefore={max_priceBefore}
                      min_priceBefore={min_priceBefore}
                      max_elasticity={max_elasticity}
                      min_elasticity={min_elasticity}
                      handleChangeElasticity={handleChangeElasticity}
                      setMax_weight_before={setMax_weight_before}
                      setMin_weight_before={setMin_weight_before}
                      max_weight_before={max_weight_before}
                      min_weight_before={min_weight_before}
                      max_weight={max_weight}
                      min_weight={min_weight}
                      handleChangeWeight={handleChangeWeight}
                    />
                  </div>
                </Drawer>
                <div className="filter_tags">
                  {(max_price_allowed !== max_price ||
                    min_price_allowed !== min_price) && (
                    <div className="filter_tag">
                      <p>{`${min_price} - ${max_price}`}</p>
                      <span
                        onClick={() => {
                          setMax_price(prices.max_price);
                          setMin_price(prices.min_price);
                          setMin_priceBefore(prices.min_price);
                          setMax_priceBefore(prices.max_price);
                        }}
                      >
                        X
                      </span>
                    </div>
                  )}
                  {(max_elasticity !== max_elasticity_allowed ||
                    min_elasticity !== min_elasticity_allowed) && (
                    <div className="filter_tag">
                      <p>{`${min_elasticity} - ${max_elasticity}`}</p>
                      <span
                        onClick={() => {
                          setMax_elasticity(
                            elasticity_fabric.max_elasticity_value
                          );
                          setMin_elasticity(
                            elasticity_fabric.min_elasticity_value
                          );
                          setMax_elasticity_before(
                            elasticity_fabric.max_elasticity_value
                          );
                          setMin_elasticity_before(
                            elasticity_fabric.min_elasticity_value
                          );
                        }}
                      >
                        X
                      </span>
                    </div>
                  )}
                  {(max_weight !== max_weight_allowed ||
                    min_weight !== min_weight_allowed) && (
                    <div className="filter_tag">
                      <p>Weight : {`${min_weight} - ${max_weight}`}</p>
                      <span
                        onClick={() => {
                          setMax_weight(weight_fabric.max_weight_value);
                          setMin_weight(weight_fabric.min_weight_value);
                          setMax_weight_before(weight_fabric.max_weight_value);
                          setMin_weight_before(weight_fabric.min_weight_value);
                        }}
                      >
                        X
                      </span>
                    </div>
                  )}
                  {filters &&
                    filters.map((el: any, i: number) => (
                      <div className="filter_tag" key={i}>
                        <p>{el.name}</p>
                        <span
                          onClick={() => {
                            deleteFilterTag(el);
                            dispatch(deleteFilter(el.name));
                          }}
                        >
                          X
                        </span>
                      </div>
                    ))}
                </div>
              </div>
            </div>
            {isLoading ? (
              <div className="row ">
                {Array.from({ length: 10 }, (_, index) => index + 1).map(
                  (_, i) => (
                    <div className="col-12 col-md-2" key={i}>
                      <div className="d-flex flex-column">
                        <Card
                          loading={isLoading}
                          bordered={false}
                          style={{ width: "100%" }}
                          bodyStyle={{ padding: "5px" }}
                          cover={
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                              src={placeholder_jeans}
                            />
                          }
                        >
                          <Meta title={"Code"} description={"Name"} />
                        </Card>
                      </div>
                    </div>
                  )
                )}{" "}
              </div>
            ) : products &&
              products.filter((product: any) => {
                if (params.fabric) {
                  return product.fabric_type === params.fabric;
                } else return product;
              }).length > 0 ? (
              <Droppable
                droppableId={`products-list-droppable`}
                direction="horizontal"
              >
                {(provided, snapshot) => (
                  <div
                    className="products-grid"
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                  >
                    {products.map((product: any, index: number) => {
                      if (products.length === index + 1) {
                        return (
                          <div
                            ref={lastProductElementRef}
                            key={product.id || index}
                            style={{ display: "contents" }}
                          >
                            <ExampleProductCard
                              index={index}
                              productPage={true}
                              foryou={forYouCompany}
                              product={product}
                              onClick={() => openQuickView(product)}
                              item={{
                                main: product.images[0]
                                  ? product.images[0].path
                                  : "",
                                onHover: product.images[1]
                                  ? product.images[1].path
                                  : "",
                              }}
                            />
                          </div>
                        );
                      } else {
                        return (
                          <ExampleProductCard
                            key={product.id || index}
                            index={index}
                            productPage={true}
                            foryou={forYouCompany}
                            product={product}
                            onClick={() => openQuickView(product)}
                            item={{
                              main: product.images[0]
                                ? product.images[0].path
                                : "",
                              onHover: product.images[1]
                                ? product.images[1].path
                                : "",
                            }}
                          />
                        );
                      }
                    })}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            ) : filters && filters.length !== 1 && products.length === 0 ? (
              <div className="unavailable_products_container">
                <h3 className="unavailable_products">
                  No products available with the selected filters !
                </h3>
              </div>
            ) : (
              filters &&
              filters.length === 0 &&
              products.length === 0 && (
                <div className="unavailable_products_container">
                  <h3 className="unavailable_products">
                    No products available for you for the moment !
                  </h3>
                </div>
              )
            )}
            {isLoadingNext && (
              <div className="text-center py-4 w-100">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
       <Drawer
              title="Product Details"
              placement="right"
              width={720}
              onClose={() => setQuickViewVisible(false)}
              visible={quickViewVisible}
              bodyStyle={{ padding: 0 }}
            >
              {quickViewProduct && (
                <div className="product_details_contanier" style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                  <div className="product_details_infos_scroll" style={{ border: "none", flex: 1, overflowY: "auto" }}>
                    <div className="product_details_infos" style={{ height: "auto", overflow: "visible" }}>
                                   <div className="component_details">

                      {quickViewProduct.fabric_type === "denim" && (
                        <DenimProduct
                          oneProduct={quickViewProduct}
                          editMode={false}
                          setEditMode={() => {}}
                        />
                      )}
                      {(quickViewProduct.fabric_type === "knit" || quickViewProduct.fabric_type === "home_textile") && (
                        <KnitProduct
                          oneProduct={quickViewProduct}
                          editMode={false}
                          setEditMode={() => {}}
                        />
                      )}
                      {quickViewProduct.fabric_type === "mix" && (
                        <MixProduct
                          oneProduct={quickViewProduct}
                          editMode={false}
                          setEditMode={() => {}}
                        />
                      )}

                      {!["denim", "knit", "mix"].includes(quickViewProduct.fabric_type) && quickViewProduct.fabric_types && (
                          <>
                             {quickViewProduct.fabric_types.name?.toLowerCase() === "denim" && <DenimProduct oneProduct={quickViewProduct} editMode={false} setEditMode={() => {}} />}
                             {quickViewProduct.fabric_types.name?.toLowerCase() === "knit" && <KnitProduct oneProduct={quickViewProduct} editMode={false} setEditMode={() => {}} />}
                             {quickViewProduct.fabric_types.name?.toLowerCase() === "mix" && <MixProduct oneProduct={quickViewProduct} editMode={false} setEditMode={() => {}} />}
                          </>
                      )}
</div>
                      {folders && folders.folders && folders.folders.length > 0 && (
                      <div  style={{ position: "relative", padding: "20px", background: "#fff", height: "auto", minHeight: "400px" }}>
                     

                          {showCollectionForm ? (
                              <div className="create_collection_form_modern" style={{ 
                                  padding: "24px", 
                                  background: "#fdfdfd", 
                                  border: "1px solid #e2e8f0", 
                                  borderRadius: "16px",
                                  boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "20px"
                              }}>
                                  <h3 style={{ fontSize: "18px", fontWeight: 700, color: "#1e293b", margin: 0 }}>New Collection</h3>
                                  
                                  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                      <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Name</label>
                                      <input
                                          type="text"
                                          placeholder="e.g. Summer 2024"
                                          value={folderData.name}
                                          onChange={(e) => setFolderData({ ...folderData, name: e.target.value })}
                                          style={{ 
                                              border: "1px solid #e2e8f0", 
                                              borderRadius: "8px", 
                                              width: "100%", 
                                              outline: "none", 
                                              fontSize: "14px", 
                                              padding: "10px 14px",
                                              background: "white",
                                              transition: "border-color 0.2s"
                                          }}
                                          onFocus={(e) => e.target.style.borderColor = "#00468c"}
                                          onBlur={(e) => e.target.style.borderColor = "#e2e8f0"}
                                      />
                                  </div>

                                  <div style={{ display: "flex", gap: "16px" }}>
                                      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                                          <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Season</label>
                                          <ReactSelect
                                              placeholder="Select Season"
                                              options={options_season}
                                              value={options_season.find(o => o.value === folderData.season)}
                                              onChange={(val: any) => setFolderData({ ...folderData, season: val.value })}
                                              styles={customStylesCreateModern}
                                          />
                                      </div>
                                      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                                          <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Year</label>
                                          <ReactSelect
                                              placeholder="Select Year"
                                              options={options_year}
                                              value={options_year.find(o => o.value === folderData.year)}
                                              onChange={(val: any) => setFolderData({ ...folderData, year: val.value })}
                                              styles={customStylesCreateModern}
                                          />
                                      </div>
                                  </div>

                                  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                      <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Collaborators</label>
                                      <ReactSelect
                                          isMulti
                                          placeholder="Search names..."
                                          options={collaborators?.map((c: any) => ({ label: c.name, value: c.id }))}
                                          onChange={(val: any) => setFolderData({ ...folderData, collaborator: val.map((v: any) => v.value) })}
                                          styles={customStylesCreateModern}
                                      />
                                  </div>

                                  <div className="buttons_grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginTop: "8px" }}>
                                      <button 
                                          className="btn_modern_cancel"
                                          onClick={() => setShowCollectionForm(false)}
                                          style={{
                                              padding: "12px",
                                              borderRadius: "10px",
                                              border: "1px solid #e1e8f0",
                                              background: "white",
                                              fontSize: "14px",
                                              fontWeight: 600,
                                              cursor: "pointer",
                                              transition: "all 0.2s"
                                          }}
                                          onMouseOver={(e) => e.currentTarget.style.background = "#f8fafc"}
                                          onMouseOut={(e) => e.currentTarget.style.background = "white"}
                                      >
                                          Cancel
                                      </button>
                                      <button 
                                          className="btn_modern_confirm"
                                          onClick={handleCreateNewFolder}
                                          style={{
                                              padding: "12px",
                                              borderRadius: "10px",
                                              border: "none",
                                              background: "#00468c",
                                              color: "white",
                                              fontSize: "14px",
                                              fontWeight: 600,
                                              cursor: "pointer",
                                              transition: "all 0.2s"
                                          }}
                                          onMouseOver={(e) => e.currentTarget.style.opacity = "0.9"}
                                          onMouseOut={(e) => e.currentTarget.style.opacity = "1"}
                                      >
                                          Create
                                      </button>
                                  </div>
                              </div>
                          ) : (
                              <>
                                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                                      <span style={{ fontSize: "14px", fontWeight: 600, color: "#64748b" }}>Choose a collection</span>
                                      <Tooltip title="Create New Collection">
                                          <button
                                              onClick={() => setShowCollectionForm(true)}
                                              style={{ 
                                                  width: "36px", 
                                                  height: "36px", 
                                                  borderRadius: "50%", 
                                                  border: "1px solid #e1e8f0", 
                                                  background: "white",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  cursor: "pointer",
                                                  color: "#00468c",
                                                  transition: "all 0.2s"
                                              }}
                                              onMouseOver={(e) => e.currentTarget.style.background = "#f1f5f9"}
                                              onMouseOut={(e) => e.currentTarget.style.background = "white"}
                                          >
                                              <PlusIcon />
                                          </button>
                                      </Tooltip>
                                  </div>

                                  <div className="list_folders" style={{ display: "grid", gridTemplateColumns:"repeat(2,1fr)", gap: "8px", maxHeight: "300px", overflowY: "auto", padding: "10px" }}>
                                      {folders.folders &&
                                          folders.folders
                                              .filter((el: any) => el.client_id == user.id)
                                              .map((folder: any) => (
                                                  <Folder
                                                      clickable={true}
                                                      selectOneFolder={true}
                                                      addToCollection={true}
                                                      folder={folder}
                                                      key={folder.id}
                                                  />
                                              ))}
                                  </div>

                                  <div className="buttons_grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginTop: "20px" }}>
                             
                                      <button 
                                          className="btn_modern_confirm"
                                          onClick={() => {
                                              if (folders.folderIdToMoveTo) {
                                                  dispatch(addProducttoFolder(folders.folderIdToMoveTo, quickViewProduct?.id));
                                                  dispatch(clearfolderToMoveTo());
                                              } else {
                                                  message.error("Please select a collection first");
                                              }
                                          }}
                                          style={{
                                              padding: "8px",
                                              borderRadius: "8px",
                                              border: "none",
                                              background: "#00468c",
                                              color: "white",
                                              fontSize: "13px",
                                              fontWeight: 600,
                                              cursor: "pointer"
                                          }}
                                      >
                                          Confirm
                                      </button>
                                  </div>
                              </>
                          )}


                      </div>)}

                    </div>
                  </div>
                  <div style={{ padding: "10px 30px 20px" }}>
                    <Link
                      to={`/product/details/${params.fabric || "denim"}/${params.genderId || "1"}/${params.categoryId || "1"}/${quickViewProduct.name}/${quickViewProduct.id}`}
                      className="ant-btn ant-btn-primary ant-btn-block"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "50px",
                        fontSize: "16px",
                        borderRadius: "4px",
                        backgroundColor: "#000",
                        borderColor: "#000",
                        fontWeight: "bold",
                        textTransform: "uppercase"
                      }}
                    >
                      VIEW FULL DETAILS
                    </Link>
                  </div>
                </div>
                )}
            </Drawer>
            <BottomDrawer mode="add_to_collection" />
    </DragDropContext>
  );
};
